/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How multi-remote authn challenges are presented: chain | interactive.
 */
export const CreateUserSessionIssuerFormAuthnChallengeMode = {
  Chain: "chain",
  Interactive: "interactive",
} as const;
/**
 * How multi-remote authn challenges are presented: chain | interactive.
 */
export type CreateUserSessionIssuerFormAuthnChallengeMode = ClosedEnum<
  typeof CreateUserSessionIssuerFormAuthnChallengeMode
>;

/**
 * Authorization-server topology. Shared mode supports standalone workload token exchange without an MCP server.
 */
export const CreateUserSessionIssuerFormAuthorizationServerMode = {
  Endpoint: "endpoint",
  Shared: "shared",
} as const;
/**
 * Authorization-server topology. Shared mode supports standalone workload token exchange without an MCP server.
 */
export type CreateUserSessionIssuerFormAuthorizationServerMode = ClosedEnum<
  typeof CreateUserSessionIssuerFormAuthorizationServerMode
>;

/**
 * Form for creating a user_session_issuer.
 */
export type CreateUserSessionIssuerForm = {
  /**
   * How multi-remote authn challenges are presented: chain | interactive.
   */
  authnChallengeMode: CreateUserSessionIssuerFormAuthnChallengeMode;
  /**
   * Authorization-server topology. Shared mode supports standalone workload token exchange without an MCP server.
   */
  authorizationServerMode?:
    | CreateUserSessionIssuerFormAuthorizationServerMode
    | undefined;
  /**
   * Maximum issued user session lifetime, in hours.
   */
  sessionDurationHours: number;
  /**
   * Issuer slug. Unique for project-owned issuers; organization-owned issuer slugs may repeat.
   */
  slug: string;
};

/** @internal */
export const CreateUserSessionIssuerFormAuthnChallengeMode$outboundSchema:
  z.ZodMiniEnum<typeof CreateUserSessionIssuerFormAuthnChallengeMode> = z.enum(
    CreateUserSessionIssuerFormAuthnChallengeMode,
  );

/** @internal */
export const CreateUserSessionIssuerFormAuthorizationServerMode$outboundSchema:
  z.ZodMiniEnum<typeof CreateUserSessionIssuerFormAuthorizationServerMode> = z
    .enum(CreateUserSessionIssuerFormAuthorizationServerMode);

/** @internal */
export type CreateUserSessionIssuerForm$Outbound = {
  authn_challenge_mode: string;
  authorization_server_mode: string;
  session_duration_hours: number;
  slug: string;
};

/** @internal */
export const CreateUserSessionIssuerForm$outboundSchema: z.ZodMiniType<
  CreateUserSessionIssuerForm$Outbound,
  CreateUserSessionIssuerForm
> = z.pipe(
  z.object({
    authnChallengeMode:
      CreateUserSessionIssuerFormAuthnChallengeMode$outboundSchema,
    authorizationServerMode: z._default(
      CreateUserSessionIssuerFormAuthorizationServerMode$outboundSchema,
      "endpoint",
    ),
    sessionDurationHours: z.int(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      authnChallengeMode: "authn_challenge_mode",
      authorizationServerMode: "authorization_server_mode",
      sessionDurationHours: "session_duration_hours",
    });
  }),
);

export function createUserSessionIssuerFormToJSON(
  createUserSessionIssuerForm: CreateUserSessionIssuerForm,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerForm$outboundSchema.parse(
      createUserSessionIssuerForm,
    ),
  );
}
